interface SocialPlatform {
  name: string;
  iconComponent: string;
  patterns: RegExp[];
  extractId: (url: string) => string;
  formatId: (id: string) => string;
}

const socialPlatforms: SocialPlatform[] = [
  {
    name: 'Instagram',
    iconComponent: 'SocialInstagramIcon',
    patterns: [/instagram\.com\/([^/?]+)/],
    extractId: (url: string) => {
      const match = url.match(/instagram\.com\/([^/?]+)/);
      return match?.[1] || '';
    },
    formatId: (id: string) => `@${id}`,
  },
  {
    name: 'Facebook',
    iconComponent: 'SocialFacebookIcon',
    patterns: [/facebook\.com\/([^/?]+)/, /fb\.com\/([^/?]+)/],
    extractId: (url: string) => {
      const match = url.match(/facebook\.com\/([^/?]+)|fb\.com\/([^/?]+)/);
      return match?.[1] || match?.[2] || '';
    },
    formatId: (id: string) => `@${id}`,
  },
  {
    name: 'Twitter/X',
    iconComponent: 'SocialTwitterIcon',
    patterns: [/twitter\.com\/([^/?]+)/, /x\.com\/([^/?]+)/],
    extractId: (url: string) => {
      const match = url.match(/twitter\.com\/([^/?]+)|x\.com\/([^/?]+)/);
      return match?.[1] || match?.[2] || '';
    },
    formatId: (id: string) => `@${id}`,
  },
  {
    name: 'GitHub',
    iconComponent: 'SocialGithubIcon',
    patterns: [/github\.com\/([^/?]+)/],
    extractId: (url: string) => {
      const match = url.match(/github\.com\/([^/?]+)/);
      return match?.[1] || '';
    },
    formatId: (id: string) => `@${id}`,
  },
  {
    name: 'VK',
    iconComponent: 'SocialVKIcon',
    patterns: [/vk\.com\/([^/?]+)/],
    extractId: (url: string) => {
      const match = url.match(/vk\.com\/([^/?]+)/);
      return match?.[1] || '';
    },
    formatId: (id: string) => `@${id}`,
  },
  {
    name: 'Telegram',
    iconComponent: 'SocialTelegramIcon',
    patterns: [/t\.me\/([^/?]+)/],
    extractId: (url: string) => {
      const match = url.match(/t\.me\/([^/?]+)/);
      return match?.[1] || '';
    },
    formatId: (id: string) => `@${id}`,
  },
  {
    name: 'YouTube',
    iconComponent: 'SocialYoutubeIcon',
    patterns: [
      /youtube\.com\/channel\/([^/?]+)/,
      /youtube\.com\/c\/([^/?]+)/,
      /youtube\.com\/user\/([^/?]+)/,
    ],
    extractId: (url: string) => {
      const match = url.match(/youtube\.com\/(?:channel\/|c\/|user\/)([^/?]+)/);
      return match?.[1] || '';
    },
    formatId: (id: string) => `@${id}`,
  },
  {
    name: 'TikTok',
    iconComponent: 'SocialTikTokIcon',
    patterns: [/tiktok\.com\/@([^/?]+)/],
    extractId: (url: string) => {
      const match = url.match(/tiktok\.com\/@([^/?]+)/);
      return match?.[1] || '';
    },
    formatId: (id: string) => `@${id}`,
  },
];

export const detectSocialPlatform = (url: string): SocialPlatform | null => {
  if (!url) return null;

  for (const platform of socialPlatforms) {
    for (const pattern of platform.patterns) {
      if (pattern.test(url)) {
        return platform;
      }
    }
  }

  return null;
};

export const formatSocialLink = (url: string): string => {
  if (!url) return '';

  const platform = detectSocialPlatform(url);
  if (platform) {
    const id = platform.extractId(url);
    return id ? platform.formatId(id) : `@${platform.name.toLowerCase()}`;
  }

  try {
    const urlObj = new URL(url.startsWith('http') ? url : `https://${url}`);
    const hostname = urlObj.hostname.toLowerCase();
    return `@${hostname.replace('www.', '')}`;
  } catch {
    return url.startsWith('@') ? url : `@${url}`;
  }
};

export { socialPlatforms };
